import { z } from "zod";
export const PERMISSIONS = {
    // Organizasyon
    "org.company.read": { module: "Organizasyon", description: "Şirketleri görüntüleme" },
    "org.company.manage": { module: "Organizasyon", description: "Şirket ekleme ve düzenleme" },
    "org.region.manage": { module: "Organizasyon", description: "Bölge ekleme ve düzenleme" },
    "stations.read": { module: "İstasyonlar", description: "İstasyonları görüntüleme" },
    "stations.manage": {
        module: "İstasyonlar",
        description: "İstasyon ekleme, düzenleme, iş birimlerini yönetme",
    },
    "stations.import": { module: "İstasyonlar", description: "Toplu istasyon içe aktarma" },
    "stations.assets.manage": {
        module: "İstasyonlar",
        description: "Tank, pompa, tabanca ve cihaz tanımlarını yönetme; kalibrasyon tablosu yükleme",
    },
    // Katalog
    "catalog.product.read": { module: "Katalog", description: "Ürün ve hizmet kataloğunu görüntüleme" },
    "catalog.product.manage": { module: "Katalog", description: "Ürün, barkod ve kategori yönetimi" },
    // Kullanıcılar ve yetkiler
    "iam.user.read": { module: "Kullanıcılar", description: "Kullanıcıları ve davetleri görüntüleme" },
    "iam.user.invite": { module: "Kullanıcılar", description: "Kullanıcı davet etme ve daveti iptal etme" },
    "iam.user.manage": {
        module: "Kullanıcılar",
        description: "Kullanıcı üyeliğini askıya alma ve kaldırma",
        stepUp: true,
    },
    "iam.role.read": { module: "Kullanıcılar", description: "Rolleri ve izinleri görüntüleme" },
    "iam.role.manage": {
        module: "Kullanıcılar",
        description: "Rol oluşturma ve izinlerini düzenleme",
        stepUp: true,
    },
    "iam.role.assign": {
        module: "Kullanıcılar",
        description: "Kullanıcılara rol atama ve kaldırma",
        stepUp: true,
    },
    "iam.security.manage": {
        module: "Kullanıcılar",
        description: "Kiracı güvenlik ayarları (2FA zorunluluğu)",
        stepUp: true,
    },
    // Denetim
    "audit.log.read": { module: "Denetim", description: "Denetim izini görüntüleme" },
    // Dosyalar
    "files.upload": { module: "Dosyalar", description: "Dosya yükleme" },
    "files.read": { module: "Dosyalar", description: "Dosya indirme" },
    // Sonraki modüllerde kullanılacak, guard'larda şimdiden anılan izinler
    "accounting.entry.read": {
        module: "Muhasebe",
        description: "Muhasebe fişlerini ve raporlarını görüntüleme",
    },
    "accounting.entry.manage": {
        module: "Muhasebe",
        description: "Taslak muhasebe fişi oluşturma, düzenleme ve silme",
    },
    "accounting.entry.post": { module: "Muhasebe", description: "Muhasebe fişi kesinleştirme", stepUp: false },
    "accounting.entry.reverse": { module: "Muhasebe", description: "Kesinleşmiş fişin ters kaydını alma" },
    "accounting.chart.manage": {
        module: "Muhasebe",
        description: "Hesap planı, masraf merkezi ve muhasebe ayarları yönetimi",
    },
    "accounting.mapping.manage": {
        module: "Muhasebe",
        description: "Hesap eşleştirmeleri ve eşleştirme bekleyen kayıtların yönetimi",
    },
    "accounting.period.override": {
        module: "Muhasebe",
        description: "Geçici kapatılmış (SOFT_CLOSED) döneme kayıt atma",
    },
    "accounting.period.close": {
        module: "Muhasebe",
        description: "Muhasebe dönemi kapatma ve açma",
        stepUp: true,
    },
    "accounting.export": { module: "Muhasebe", description: "Muhasebe verisini dışa aktarma" },
    // Kasa, banka, POS
    "treasury.read": {
        module: "Kasa, banka, POS",
        description: "Kasa, banka, POS, teminat, DBS ve kredi kayıtlarını ve raporlarını görüntüleme",
    },
    "treasury.definition.manage": {
        module: "Kasa, banka, POS",
        description: "Kasa, banka hesabı, POS terminali, eşleştirme kuralı, ekstre şablonu ve hazine ayarlarını yönetme",
    },
    "treasury.txn.create": {
        module: "Kasa, banka, POS",
        description: "Kasa ve banka hareketi (tahsil, tediye, transfer, masraf, faiz, açılış) kaydetme",
    },
    "treasury.txn.cancel": {
        module: "Kasa, banka, POS",
        description: "Kasa ve banka hareketini iptal etme (ters kayıt)",
    },
    "treasury.count.create": { module: "Kasa, banka, POS", description: "Kasa sayımı girme" },
    "treasury.count.approve": {
        module: "Kasa, banka, POS",
        description: "Kasa sayım farkını onaylama ya da reddetme",
    },
    "treasury.statement.manage": {
        module: "Kasa, banka, POS",
        description: "Banka ekstresi içe aktarma ve satır eşleştirme",
    },
    "treasury.pos.manage": {
        module: "Kasa, banka, POS",
        description: "POS gün sonu toplamı ve yatış mutabakatı kaydetme",
    },
    "treasury.guarantee.manage": {
        module: "Kasa, banka, POS",
        description: "Teminat mektubu, ipotek ve rehin kayıtlarını yönetme",
    },
    "treasury.dbs.manage": {
        module: "Kasa, banka, POS",
        description: "DBS anlaşmaları ve ödeme planını yönetme",
    },
    "treasury.loan.manage": {
        module: "Kasa, banka, POS",
        description: "Banka kredisi ve taksit planını yönetme",
    },
    // Cari hesaplar
    "counterparty.card.read": {
        module: "Cari hesaplar",
        description: "Cari kartları, hareketleri ve açık kalemleri görüntüleme",
    },
    "counterparty.card.manage": { module: "Cari hesaplar", description: "Cari kart açma ve düzenleme" },
    "counterparty.limit.read": {
        module: "Cari hesaplar",
        description: "Cari risk ve limit sorgulama (kasa ve filo satışları için)",
    },
    "counterparty.limit.manage": {
        module: "Cari hesaplar",
        description: "Kredi limiti, çek risk limiti, limit politikası ve blokaj yönetimi",
    },
    "counterparty.txn.create": {
        module: "Cari hesaplar",
        description: "Tahsilat, ödeme, dekont, virman ve açılış bakiyesi girme",
    },
    "counterparty.txn.cancel": {
        module: "Cari hesaplar",
        description: "Cari hareketini iptal etme (ters kayıt)",
    },
    "counterparty.allocation.manage": {
        module: "Cari hesaplar",
        description: "Açık kalem eşleştirme ve eşleştirmeyi geri alma",
    },
    "counterparty.report.read": {
        module: "Cari hesaplar",
        description: "Cari ekstre, yaşlandırma, vade takvimi, Ba/Bs ve risk panosu",
    },
    "counterparty.reconciliation.manage": {
        module: "Cari hesaplar",
        description: "Mutabakat mektubu, ekstre gönderimi ve tahsilat hatırlatma",
    },
    "cheques.read": { module: "Çek ve senet", description: "Çek/senet portföyü, bordrolar ve raporlar" },
    "cheques.status.change": {
        module: "Çek ve senet",
        description: "Çek/senet girişi, keşide ve bordroyla durum değiştirme (tahsil, ciro, bankaya verme…)",
    },
    "cheques.bounce": {
        module: "Çek ve senet",
        description: "Karşılıksız dönüş, protesto ve şüpheli alacaktan silme kaydı",
    },
    "cheques.batch.cancel": {
        module: "Çek ve senet",
        description: "Hatalı bordroyu iptal etme (fişin ters kaydı, çeklerin önceki durumuna dönmesi)",
    },
    "cheques.book.manage": {
        module: "Çek ve senet",
        description: "Çek karnesi tanımlama, yaprak iptal / kayıp",
    },
    "cheques.settings.manage": {
        module: "Çek ve senet",
        description: "Çek/senet ayarları ve keşideci risk işaretleri",
    },
    "invoices.read": {
        module: "Fatura ve e-belge",
        description: "Faturalar, irsaliyeler, gelen kutusu ve e-belge durumları",
    },
    "invoices.sales.manage": {
        module: "Fatura ve e-belge",
        description: "Satış faturası ve müşteri iadesi hazırlama, kesinleştirme; fişli satışların faturalanması",
    },
    "invoices.purchase.manage": {
        module: "Fatura ve e-belge",
        description: "Alış faturası ve tedarikçiye iade kaydı; gelen faturayı deftere alma",
    },
    "invoices.cancel": {
        module: "Fatura ve e-belge",
        description: "Kesinleşmiş faturayı iptal etme (fişin ters kaydı, e-Arşiv iptali)",
        stepUp: true,
    },
    "invoices.send": {
        module: "Fatura ve e-belge",
        description: "e-Belgeyi sağlayıcıya gönderme / yeniden gönderme",
    },
    "invoices.incoming.respond": {
        module: "Fatura ve e-belge",
        description: "Gelen ticari faturaya kabul / red yanıtı verme",
    },
    "invoices.despatch.manage": {
        module: "Fatura ve e-belge",
        description: "Sevk ve alış irsaliyesi hazırlama, kesinleştirme, iptal",
    },
    "invoices.settings.manage": {
        module: "Fatura ve e-belge",
        description: "Fatura serileri, fatura ayarları ve e-belge sağlayıcı bilgileri",
        stepUp: true,
    },
    // Giderler (özellik bayrağı `EXPENSES_BUDGET`)
    "expenses.read": {
        module: "Giderler",
        description: "Giderleri, dağıtım anahtarlarını, sayaçları ve gider raporlarını görüntüleme",
    },
    "expenses.manage": {
        module: "Giderler",
        description: "Gider belgesi girme, düzenleme ve onaya gönderme",
    },
    "expenses.cancel": {
        module: "Giderler",
        description: "Onaylanmış gideri iptal etme (ters fiş, açık kalem iptali, hazine iptali)",
        stepUp: true,
    },
    "expenses.definition.manage": {
        module: "Giderler",
        description: "Gider kategorisi, dağıtım anahtarı, sayaç, şirket kartı ve tekrarlayan gider tanımlarını yönetme",
    },
    // Vergi ve beyan takvimi (özellik bayrağı `EXPENSES_BUDGET`)
    "taxcalendar.read": {
        module: "Vergi takvimi",
        description: "Beyan / ödeme takvimini, yükümlülükleri ve KDV özetini görüntüleme",
    },
    "taxcalendar.manage": {
        module: "Vergi takvimi",
        description: "Takvim kurallarını ve yükümlülükleri yönetme (tutar girme, tamamlandı işaretleme)",
    },
    // Ödeme planlama (özellik bayrağı `EXPENSES_BUDGET`)
    "payments.read": {
        module: "Ödeme planlama",
        description: "Ödeme listesini ve ödeme partilerini görüntüleme",
    },
    "payments.manage": {
        module: "Ödeme planlama",
        description: "Ödeme partisi hazırlama, satır ekleme / çıkarma, onaya gönderme ve iptal",
    },
    "payments.execute": {
        module: "Ödeme planlama",
        description: "Onaylanmış ödeme partisini yürütme ve banka toplu ödeme dosyasını indirme",
        stepUp: true,
    },
    // Nakit akış (özellik bayrağı `EXPENSES_BUDGET`)
    "cashflow.read": {
        module: "Nakit akış",
        description: "Nakit akış projeksiyonunu, senaryo karşılaştırmasını ve gün kalemlerini görüntüleme",
    },
    "cashflow.manage": {
        module: "Nakit akış",
        description: "Nakit akış ayarlarını (ufuk, alarm senaryosu, senaryo parametreleri) yönetme",
    },
    // Bütçe (özellik bayrağı `EXPENSES_BUDGET`)
    "budget.read": {
        module: "Bütçe",
        description: "Bütçeleri ve gerçekleşen–bütçe raporunu görüntüleme",
    },
    "budget.manage": {
        module: "Bütçe",
        description: "Bütçe oluşturma, satır girme, Excel içe aktarma, sürüm açma ve yürürlüğe alma",
    },
    // Onay akışları (motorun özellik bayrağı yoktur; her kiracıda açıktır)
    "approvals.read": {
        module: "Onaylar",
        description: "Onay politikalarını ve onay taleplerini görüntüleme",
    },
    "approvals.policy.manage": {
        module: "Onaylar",
        description: "Onay politikalarını (adımlar, onaycılar, eşikler) yönetme",
        stepUp: true,
    },
    "approvals.delegation.manage": {
        module: "Onaylar",
        description: "Başkası adına onay vekâleti tanımlama ve kaldırma (kendi vekâletini herkes tanımlar)",
    },
    "approvals.request.view_all": {
        module: "Onaylar",
        description: "Kiracıdaki tüm onay taleplerini görüntüleme",
    },
    "fuel.price.read": { module: "Fiyatlar", description: "Fiyatları ve fiyat geçmişini görüntüleme" },
    "fuel.price.change": { module: "Fiyatlar", description: "Fiyat değişikliği hazırlama ve onaya gönderme" },
    "fuel.price.approve": {
        module: "Fiyatlar",
        description: "Fiyat değişikliğini onaylama, planlama ve iptal etme",
        stepUp: true,
    },
    // Akaryakıt operasyonu (özellik bayrağı `FUEL`)
    "fuel.ops.read": {
        module: "Akaryakıt operasyonu",
        description: "Tank durumu, satışlar, endeksler, dolumlar ve mutabakat raporlarını görüntüleme",
    },
    "fuel.reading.create": {
        module: "Akaryakıt operasyonu",
        description: "Elle tank ve endeks okuması girme (pompacı / kasiyer)",
    },
    "fuel.ingest": {
        module: "Akaryakıt operasyonu",
        description: "İstasyon ajanı / entegrasyon ile toplu tank, satış ve endeks verisi gönderme",
    },
    "fuel.delivery.manage": {
        module: "Akaryakıt operasyonu",
        description: "Tanker dolumu kaydetme, öncesi / sonrası okumaları ve ölçümü girme",
    },
    "fuel.delivery.confirm": {
        module: "Akaryakıt operasyonu",
        description: "Dolumu onaylama (stok girişi) ya da itiraz etme",
    },
    "fuel.order.manage": {
        module: "Akaryakıt operasyonu",
        description: "Akaryakıt siparişi hazırlama, onaya gönderme ve dağıtıcıya iletme",
    },
    "fuel.reconciliation.approve": {
        module: "Akaryakıt operasyonu",
        description: "Islak stok mutabakatını onaylama ve farkı fire olarak kaydetme",
        stepUp: true,
    },
    "fuel.totalizer.adjust": {
        module: "Akaryakıt operasyonu",
        description: "Tabanca endeksinin elle düzeltilmesini talep etme (gerekçe + onay)",
    },
    "fuel.settings.manage": {
        module: "Akaryakıt operasyonu",
        description: "Akaryakıt operasyonu ayarlarını (tolerans, eşik, maliyet kapsamı) yönetme",
    },
    // Vardiya, pompacı hesabı ve gün sonu (özellik bayrağı `SHIFTS`)
    "shifts.read": {
        module: "Vardiya ve gün sonu",
        description: "Vardiyaları, panoyu, pompacı hesaplarını, Z raporlarını ve gün sonu raporlarını görüntüleme",
    },
    "shifts.manage": {
        module: "Vardiya ve gün sonu",
        description: "Vardiya açma, personel / şablon tanımlama, atama ve devir, vardiya içi kayıtlar (ara teslim, masraf, veresiye fişi, test çekişi)",
    },
    "shifts.close.own": {
        module: "Vardiya ve gün sonu",
        description: "Kendi vardiya hesabını girme ve teslim etme (pompacı / kasiyer)",
    },
    "shifts.close.manage": {
        module: "Vardiya ve gün sonu",
        description: "Başkası adına hesap kapatma, vardiyayı kapatma, kredi limiti aşımını onaylama",
    },
    "shifts.approve": {
        module: "Vardiya ve gün sonu",
        description: "Vardiya farkını ve vardiya kapanışını onaylama (kimse kendi hesabını onaylayamaz)",
    },
    "shifts.zreport.manage": {
        module: "Vardiya ve gün sonu",
        description: "Z raporu girme, ÖKC tanımlama ve Z farkını çözümleme",
    },
    "shifts.day.close": {
        module: "Vardiya ve gün sonu",
        description: "Gün sonu kapatma (gelir / KDV özet fişi ve gün kilidi)",
        stepUp: true,
    },
    "shifts.day.correct": {
        module: "Vardiya ve gün sonu",
        description: "Kilitlenmiş güne düzeltme kaydı girme (ek / ters fiş)",
        stepUp: true,
    },
    "shifts.settings.manage": {
        module: "Vardiya ve gün sonu",
        description: "Vardiya ayarlarını (tolerans, açık politikası, Z / tank zorunlulukları) yönetme",
    },
    // İstasyon ajanı ve cihaz entegrasyonu (özellik bayrağı `STATION_AGENT`)
    "agents.read": {
        module: "İstasyon ajanı",
        description: "Ajanları, durumlarını, heartbeat geçmişini, cihaz alarmlarını ve komut geçmişini görüntüleme",
    },
    "agents.manage": {
        module: "İstasyon ajanı",
        description: "Kayıt kodu üretme ve iptal etme, ajanı iptal etme",
    },
    "agents.command": {
        module: "İstasyon ajanı",
        description: "Ajana komut gönderme (fiyat gönder, günlük iste, adaptör yeniden başlat) ve komut iptali",
    },
    // Yerel kasa (POS) — özellik bayrağı `LOCAL_POS`
    "pos.read": {
        module: "Yerel kasa",
        description: "Kasa satışlarını, fiş ayrıntısını ve kasa raporlarını görüntüleme",
    },
    "pos.manage": {
        module: "Yerel kasa",
        description: "Kampanya tanımlama, hızlı tuş yerleşimi ve kasa ayarlarını yönetme",
    },
    "pos.staff.pin.manage": {
        module: "Yerel kasa",
        description: "Personele kasa PIN'i atama ve kaldırma (düz PIN saklanmaz)",
        stepUp: true,
    },
    // Fiyat grupları (Prompt 16) — toplu fiyat değişikliğinde istasyon seçimi kısayolu
    "pricing.group.manage": {
        module: "Fiyatlar",
        description: "Fiyat gruplarını ve üye istasyonlarını yönetme",
    },
    // Market — özellik bayrağı `MARKET` (Prompt 16)
    "market.read": {
        module: "Market",
        description: "Stok, hareketler, parti / SKT, satın alma belgeleri, sayımlar ve market raporlarını görüntüleme",
    },
    "market.catalog.manage": {
        module: "Market",
        description: "Ürün – tedarikçi bağları, istasyon ürün ayarları (min / max stok, raf yeri) ve depolar",
    },
    "market.purchase.manage": {
        module: "Market",
        description: "Sipariş önerisi, tedarikçi siparişi hazırlama, gönderme ve kapatma",
    },
    "market.receipt.manage": {
        module: "Market",
        description: "Mal kabul (barkodla okutma, kaydetme, iptal) ve açılış stoğu",
    },
    "market.invoice.match": {
        module: "Market",
        description: "Alış faturasını sipariş ve mal kabulle eşleştirme (üçlü eşleştirme) ve eşleşmeyi geri alma",
    },
    "market.stock.manage": {
        module: "Market",
        description: "İstasyonlar arası transfer (gönderme / kabul) ve fire / imha belgesi",
    },
    "market.count.manage": { module: "Market", description: "Sayım açma, okutma / giriş ve sayımı gönderme" },
    "market.count.approve": {
        module: "Market",
        description: "Sayım farkını onaylama (stok düzeltmesi ve muhasebe kaydı)",
        stepUp: true,
    },
    "market.settings.manage": {
        module: "Market",
        description: "Market ayarları (toleranslar, SKT, marj, sayım)",
    },
    "market.license.manage": {
        module: "Market",
        description: "İstasyon satış belgeleri (tütün / alkol) kaydı ve belge dosyası",
    },
    // Müşteri kimliği (Prompt 17). Kişisel veriyi AÇIK görmek ayrı izindir ve `.read` ile bitmez: salt okuma rolleri
    // (denetçi, mali müşavir) müşteriyi MASKELİ görür (KVKK — veri minimizasyonu).
    "customers.read": {
        module: "Müşteriler",
        description: "Müşteri, araç ve müşteri 360 görüntüleme (kişisel veri maskeli)",
    },
    "customers.personal.view": {
        module: "Müşteriler",
        description: "Müşterinin kişisel verilerini (ad, telefon, e-posta, plaka) açık görüntüleme",
    },
    "customers.manage": {
        module: "Müşteriler",
        description: "Müşteri ve araç ekleme / düzenleme, müşteri uygulaması bağlantı daveti",
    },
    // KVKK
    "privacy.read": {
        module: "KVKK",
        description: "Aydınlatma / rıza metinleri, rıza geçmişi ve başvuruları görüntüleme",
    },
    "privacy.manage": {
        module: "KVKK",
        description: "Metin sürümü yazma ve yayımlama, rıza / ileti izni kaydı, saklama ayarları",
    },
    "privacy.request.manage": {
        module: "KVKK",
        description: "İlgili kişi başvurusunu işleme: veri dökümü, düzeltme, anonimleştirme",
        stepUp: true,
    },
    "marketing.send": {
        module: "KVKK",
        description: "Pazarlama iletisi gönderme (izin gönderim anında denetlenir)",
    },
    // Filo ve TTS
    "fleet.read": {
        module: "Filo",
        description: "Filo hesapları, araçlar, kurallar, kullanım ve ekstreyi görüntüleme",
    },
    "fleet.manage": {
        module: "Filo",
        description: "Filo hesabı, araç, sürücü, TTS etiketi ve kural yönetimi; araç taleplerini karara bağlama",
    },
    "fleet.rule.override": {
        module: "Filo",
        description: "Elle girilen filo fişinde kural ihlalini onaylayarak geçme",
        stepUp: true,
    },
    "fleet.billing.manage": {
        module: "Filo",
        description: "Filo dönem faturasını hazırlama, kesme ve iptal etme",
    },
    // Filo portalı (yalnızca FLEET_PORTAL_USER; cari kapsamlı atamayla). `.read` ile BİTMEZ: salt okuma rollerine geçmez.
    "fleet.portal.access": {
        module: "Filo portalı",
        description: "Kendi filosunun işlemlerini, faturalarını, limitlerini ve araçlarını görme",
    },
    "fleet.portal.vehicle.request": { module: "Filo portalı", description: "Araç ekleme talebi gönderme" },
    // Sadakat
    "loyalty.read": {
        module: "Sadakat",
        description: "Program, seviye, puan hareketleri, kupon, abonelik ve yükümlülüğü görüntüleme",
    },
    "loyalty.manage": {
        module: "Sadakat",
        description: "Program ve marka ayarları, seviyeler, kazanım kuralları, kötüye kullanım incelemesi",
    },
    "loyalty.points.adjust": {
        module: "Sadakat",
        description: "Puan düzeltmesi (gerekçeli, anında muhasebeleşir)",
        stepUp: true,
    },
    "loyalty.coupon.manage": { module: "Sadakat", description: "Kupon kampanyası, kod üretimi ve iptali" },
    "loyalty.subscription.manage": {
        module: "Sadakat",
        description: "Abonelik planları ve müşteri abonelikleri",
    },
    // Yıkama (Prompt 18, ADR 0018 §3)
    "wash.read": {
        module: "Yıkama",
        description: "Üniteler, programlar, makine çalışmaları, krediler, randevu ve iş emirlerini görüntüleme",
    },
    "wash.manage": {
        module: "Yıkama",
        description: "Ünite ayarı, program, reçete (kimyasal / su / elektrik) ve yıkama ayarları",
    },
    "wash.operate": {
        module: "Yıkama",
        description: "Makine başlatma, kod / kredi işlemleri, randevu, iş emri ve fotoğraf, elle çalışma kaydı",
    },
    "wash.report.read": { module: "Yıkama", description: "Yıkama maliyet, marj, doluluk ve arıza raporları" },
    // Şarj (Prompt 19, ADR 0019 §18)
    "ev.read": {
        module: "Şarj",
        description: "Şarj üniteleri, canlı durum, oturumlar, tarifeler ve komut geçmişini görüntüleme",
    },
    "ev.manage": {
        module: "Şarj",
        description: "Ünite OCPP ayarı ve kimlik bilgisi, tarife, istasyon şarj ayarı (yük yönetimi, işletme modeli), dışa aktarım",
    },
    "ev.operate": {
        module: "Şarj",
        description: "Uzaktan şarj başlatma / durdurma, konnektör kilidi açma, erişilebilirlik, yeniden başlatma, ortak içe aktarım",
    },
    "ev.maintenance.manage": {
        module: "Şarj",
        description: "Ünite yazılım güncellemesi, tanılama dosyası ve OCPP yapılandırması değişikliği",
        stepUp: true,
    },
    "ev.report.read": {
        module: "Şarj",
        description: "Şarj enerji / maliyet / marj, doluluk, erişilemezlik ve müşteri harcaması raporları",
    },
    // Alarm ve bildirim (Prompt 20, ADR 0020 §14). Bildirim kutusu ve kişisel tercihler izin istemez.
    "alarms.read": {
        module: "Alarmlar",
        description: "Kapsamındaki alarmları görüntüleme (her alarm ayrıca kuralının hedef iznini ister)",
    },
    "alarms.manage": {
        module: "Alarmlar",
        description: "Alarmı görüldü işaretleme, atama, not ekleme, çözme ve yeniden açma",
    },
    "alarms.rules.manage": {
        module: "Alarmlar",
        description: "Alarm kurallarının kiracı / istasyon geçersiz kılmaları (etkin, önem, eşik, yükseltme süresi)",
    },
    // Raporlama ve panolar (Prompt 22, ADR 0022 §16). Kaydedilmiş filtre / favori kişiseldir, izin istemez.
    "reports.read": {
        module: "Raporlar",
        description: "Rapor merkezi ve panolar (her bölüm ayrıca kaynağının iznini ister: satış, akaryakıt, hazine, çek, cari, muhasebe)",
    },
    "reports.schedule.manage": {
        module: "Raporlar",
        description: "Zamanlanmış rapor oluşturma ve yönetme (rapor her alıcıya kendi yetkisiyle üretilir)",
    },
    "reports.settings.manage": {
        module: "Raporlar",
        description: "Rapor görünümü: PDF logosu ve altbilgi notu",
    },
    // Varlık bakımı ve uyum takvimi (Prompt 23, ADR 0023 §14). Varlık alanları (seri no, garanti, servis firması)
    // `stations.assets.manage` ile yazılır.
    "maintenance.read": {
        module: "Bakım",
        description: "Bakım planları, iş emirleri, sayaç okumaları ve bakım raporları",
    },
    "maintenance.manage": {
        module: "Bakım",
        description: "Bakım planı ve ayarları (SLA, alarmdan iş emri), elle sayaç okuması",
    },
    "maintenance.work.manage": {
        module: "Bakım",
        description: "İş emri açma, atama, ilerletme, fotoğraf ve maliyet; maliyetten taslak gider oluşturma",
    },
    "compliance.read": {
        module: "Uyum",
        description: "Uyum belgeleri, denetim ziyaretleri, düzeltici faaliyetler ve uyum takvimi",
    },
    "compliance.manage": {
        module: "Uyum",
        description: "Belge türü (öneri doğrulama), belge, yenileme, denetim ziyareti ve düzeltici faaliyet yönetimi",
    },
    // Abonelik ve platform ilişkisi (Prompt 24) — KİRACI kapsamlıdır (bölge / istasyon atamasıyla kullanılamaz).
    "tenant.billing.read": {
        module: "Abonelik",
        description: "Aboneliği, kullanım ölçümünü ve platform faturalarını görüntüleme",
    },
    "tenant.billing.manage": {
        module: "Abonelik",
        description: "Fatura profilini (unvan, VKN, adres) düzenleme",
    },
    "tenant.export.manage": {
        module: "Abonelik",
        description: "Kiracının TÜM verisinin makine tarafından okunur dışa aktarımını isteme ve indirme",
        stepUp: true,
    },
    "tenant.support.manage": {
        module: "Abonelik",
        description: "Platform destek ekibinin kiracı adına görüntüleme isteğini onaylama, reddetme, iptal etme",
    },
    "stations.transfer.approve": {
        module: "İstasyonlar",
        description: "İstasyonun başka bir hesaba devrini (ya da devralınmasını) onaylama",
        stepUp: true,
    },
};
export const ALL_PERMISSIONS = Object.keys(PERMISSIONS);
export const permissionSchema = z.enum(ALL_PERMISSIONS);
export function isPermission(value) {
    return value in PERMISSIONS;
}
export function requiresStepUp(permission) {
    return PERMISSIONS[permission].stepUp === true;
}
const readOnly = ALL_PERMISSIONS.filter((permission) => permission.endsWith(".read"));
const without = (...excluded) => ALL_PERMISSIONS.filter((permission) => !excluded.includes(permission));
/**
 * Sistem rolleri. İzinleri veritabanında DEĞİL burada tutulur: yeni izin eklendiğinde mevcut kiracıların sistem
 * rolleri kendiliğinden güncellenir. Kiracılar bu rolleri düzenleyemez; kendi özel rollerini oluşturabilir.
 */
export const SYSTEM_ROLES = {
    OWNER: { name: "Sahip", description: "İşletme sahibi; tüm yetkiler", permissions: [...ALL_PERMISSIONS] },
    ADMIN: {
        name: "Yönetici",
        description: "Güvenlik ayarları, veri dışa aktarımı ve istasyon devri onayı dışında tüm yetkiler",
        permissions: without("iam.security.manage", "tenant.export.manage", "stations.transfer.approve"),
    },
    REGION_MANAGER: {
        name: "Bölge Müdürü",
        description: "Atandığı bölgedeki istasyonların operasyonu",
        permissions: [
            ...readOnly,
            "stations.manage",
            "stations.assets.manage",
            "fuel.price.change",
            // Akaryakıt günlük operasyonu (veri alımı `fuel.ingest` YALNIZCA sahip / yöneticide: istasyon ajanı kimliği
            // Prompt 14'te gelir); mutabakat onayı da bölge müdüründe değildir (step-up + muhasebe kararı).
            "fuel.reading.create",
            "fuel.delivery.manage",
            "fuel.delivery.confirm",
            "fuel.order.manage",
            "fuel.totalizer.adjust",
            // Vardiya: bölge müdürü gün sonu düzeltmesi (kilitli güne kayıt) ve ayar YÖNETMEZ — ikisi de
            // muhasebe / şirket kararıdır; kalan vardiya yetkilerinin tamamı vardır.
            "shifts.manage",
            "shifts.close.own",
            "shifts.close.manage",
            "shifts.approve",
            "shifts.zreport.manage",
            "shifts.day.close",
            // İstasyon ajanı: bölge müdürü ajanları izler ve komut gönderir; kayıt kodu üretme / ajan iptali
            // (`agents.manage`) sahip / yöneticide kalır — yeni bir makineye kimlik vermek güvenlik kararıdır.
            "agents.command",
            // Yerel kasa: bölgesindeki kasaları izler, kampanya ve ayar yönetir; PIN atama istasyon müdüründedir.
            "pos.manage",
            // Market: bölge müdürü satın alma, transfer ve sayımı yönetir; sayım farkı onayı ve ayarlar muhasebe / şirket
            // kararıdır (yönetici). Fiyat grubu da merkezi fiyat kararıdır.
            "market.catalog.manage",
            "market.purchase.manage",
            "market.receipt.manage",
            "market.stock.manage",
            "market.count.manage",
            "market.license.manage",
            // Müşteri / filo / sadakat (Prompt 17): bölge müşteri ve filo operasyonunu yönetir; kişisel veriyi açık görür.
            // KVKK başvurusu, puan düzeltmesi ve dönem faturası yönetici / muhasebe kararıdır.
            "customers.personal.view",
            "customers.manage",
            "fleet.manage",
            "fleet.rule.override",
            "loyalty.coupon.manage",
            "loyalty.subscription.manage",
            // Yıkama (Prompt 18): bölgesindeki ünite / program tanımı ve günlük işletim.
            "wash.manage",
            "wash.operate",
            // Şarj (Prompt 19): bölgesindeki ünite, tarife ve yük ayarı, işletim ve bakım (yazılım / yapılandırma step-up ister).
            "ev.manage",
            "ev.operate",
            "ev.maintenance.manage",
            // Alarm (Prompt 20): bölgesindeki alarmları yönetir; kural ayarı (eşik / önem) yönetimdedir.
            "alarms.manage",
            "reports.schedule.manage",
            // Bakım ve uyum (Prompt 23): bölgesindeki planlar, iş emirleri, uyum belgeleri ve denetimler.
            "maintenance.manage",
            "maintenance.work.manage",
            "compliance.manage",
            "files.upload",
        ],
    },
    STATION_MANAGER: {
        name: "İstasyon Müdürü",
        description: "Atandığı istasyonun günlük operasyonu",
        permissions: [
            "stations.read",
            "stations.assets.manage",
            "org.company.read",
            "catalog.product.read",
            "approvals.read",
            "fuel.price.read",
            "fuel.price.change",
            "treasury.read",
            "treasury.count.create",
            "treasury.pos.manage",
            // İstasyon müdürü kendi istasyonunun giderini girer ve onaya gönderir; şirket geneli gideri göremez.
            "expenses.read",
            "expenses.manage",
            // Akaryakıt: istasyonun günlük operasyonu (okuma, dolum, sipariş, endeks düzeltme talebi).
            "fuel.ops.read",
            "fuel.reading.create",
            "fuel.delivery.manage",
            "fuel.delivery.confirm",
            "fuel.order.manage",
            "fuel.totalizer.adjust",
            // Vardiya ve gün sonu istasyon müdürünün ASIL işidir: tamamı ondadır.
            "shifts.read",
            "shifts.manage",
            "shifts.close.own",
            "shifts.close.manage",
            "shifts.approve",
            "shifts.zreport.manage",
            "shifts.day.close",
            "shifts.day.correct",
            "shifts.settings.manage",
            // İstasyon ajanı: kendi istasyonunun ajanını izler ve komut gönderir (`agents.manage` YOK).
            "agents.read",
            "agents.command",
            // Yerel kasa: istasyonun kasası, kampanyaları ve personel PIN'leri istasyon müdürünün işidir.
            "pos.read",
            "pos.manage",
            "pos.staff.pin.manage",
            // Market: istasyonun günlük stok işi (sipariş, mal kabul, transfer, fire, sayım) istasyon müdüründedir; sayım
            // farkını ONAYLAMAZ (kendi sayımını onaylamak denetim zafiyeti) ve eşleştirme muhasebenindir.
            "market.read",
            "market.catalog.manage",
            "market.purchase.manage",
            "market.receipt.manage",
            "market.stock.manage",
            "market.count.manage",
            "market.license.manage",
            // Müşteri (Prompt 17): istasyonda müşteri kaydı, araç ve bağlantı daveti; elle girilen filo fişinde kural onayı.
            "customers.read",
            "customers.personal.view",
            "customers.manage",
            "fleet.read",
            "fleet.rule.override",
            // Elle girilen veresiye / filo fişinde limit özeti (kasiyerdeki gibi): risk ve limit sorgusu kişisel veri taşımaz.
            // Fiş penceresinin cari seçicisi `GET /shifts/:id/credit-sale-counterparties`'tir (`counterparty.card.read` YOK).
            "counterparty.limit.read",
            "loyalty.read",
            "loyalty.subscription.manage",
            // Yıkama (Prompt 18): istasyonun ünite ayarı, program / reçete, randevu ve iş emirleri istasyon müdüründedir.
            "wash.read",
            "wash.manage",
            "wash.operate",
            "wash.report.read",
            // Şarj (Prompt 19): istasyonun ünite ayarı, tarifesi ve işletimi istasyon müdüründedir; yazılım güncellemesi ve OCPP
            // yapılandırması (`ev.maintenance.manage`) bölge / yönetimdedir.
            "ev.read",
            "ev.manage",
            "ev.operate",
            "ev.report.read",
            // Alarm (Prompt 20): istasyonunun alarmlarını görür ve yönetir (gör / ata / çöz).
            "alarms.read",
            "alarms.manage",
            "reports.read",
            "reports.schedule.manage",
            // Bakım ve uyum (Prompt 23): istasyonunun iş emirlerini yönetir, uyum belgelerini ve denetimleri girer; bakım
            // planı / ayarı bölge ve yönetimdedir.
            "maintenance.read",
            "maintenance.work.manage",
            "compliance.read",
            "compliance.manage",
            "files.upload",
            "files.read",
        ],
    },
    ACCOUNTANT: {
        name: "Muhasebe",
        description: "Muhasebe kayıtları, cari, kasa/banka",
        permissions: [
            ...readOnly,
            "accounting.entry.manage",
            "accounting.entry.post",
            "accounting.entry.reverse",
            "accounting.chart.manage",
            "accounting.mapping.manage",
            "accounting.period.close",
            "accounting.export",
            "counterparty.card.manage",
            "counterparty.limit.manage",
            "counterparty.txn.create",
            "counterparty.txn.cancel",
            "counterparty.allocation.manage",
            "counterparty.reconciliation.manage",
            "treasury.definition.manage",
            "treasury.txn.create",
            "treasury.txn.cancel",
            "treasury.count.create",
            "treasury.count.approve",
            "treasury.statement.manage",
            "treasury.pos.manage",
            "treasury.guarantee.manage",
            "treasury.dbs.manage",
            "treasury.loan.manage",
            "cheques.status.change",
            "cheques.bounce",
            "cheques.batch.cancel",
            "cheques.book.manage",
            "cheques.settings.manage",
            "invoices.sales.manage",
            "invoices.purchase.manage",
            "invoices.cancel",
            "invoices.send",
            "invoices.incoming.respond",
            "invoices.despatch.manage",
            "invoices.settings.manage",
            // Muhasebe gider modülünün tamamını yönetir (Mali Müşavir ve Denetçi salt okuma `.read` ile gelir).
            "expenses.manage",
            "expenses.cancel",
            "expenses.definition.manage",
            // Vergi takvimi ve ödeme planlama muhasebenin işidir (Mali Müşavir / Denetçi salt okuma `.read` ile gelir).
            "taxcalendar.manage",
            "payments.manage",
            "payments.execute",
            // Nakit akış ve bütçe de muhasebenin işidir (Mali Müşavir / Denetçi salt okuma `.read` ile gelir).
            "cashflow.manage",
            "budget.manage",
            // Vardiya: muhasebe farkı ONAYLAR ve GÜN SONUNU kapatır / düzeltir; vardiyayı açmaz, hesabı girmez.
            "shifts.approve",
            "shifts.day.close",
            "shifts.day.correct",
            // Market: üçlü eşleştirme (fatura ↔ mal kabul) ve sayım farkı onayı muhasebenindir.
            "market.invoice.match",
            "market.count.approve",
            // Filo dönem faturası ve puan düzeltmesi muhasebenindir (Prompt 17).
            "fleet.billing.manage",
            "loyalty.points.adjust",
            // Alarm (Prompt 20): finans / muhasebe alarmlarını yönetir (hangi alarmı gördüğü kuralın hedef izniyle süzülür).
            "alarms.manage",
            "reports.schedule.manage",
            "files.upload",
        ],
    },
    FINANCIAL_ADVISOR: {
        name: "Mali Müşavir",
        description: "Salt okuma ve muhasebe dışa aktarımı",
        permissions: [...readOnly, "accounting.export"],
    },
    CASHIER: {
        name: "Kasiyer",
        description: "Kasa ve satış işlemleri",
        permissions: [
            // Operasyon sayfaları (vardiya, akaryakıt, market, kasa) şirket seçimiyle açılır; liste kapsama göre süzülür
            // (istasyon kapsamlı kasiyer yalnızca kendi istasyonunun şirketini görür). Bu izin yokken sayfalar hiç açılmıyordu.
            "org.company.read",
            "stations.read",
            "fuel.price.read",
            "catalog.product.read",
            "counterparty.limit.read",
            "treasury.count.create",
            // Kasiyer tank durumunu görür ve elle okuma girer; toplu veri alımı (ajan) yetkisi YOKTUR.
            "fuel.ops.read",
            "fuel.reading.create",
            // Vardiya: yalnızca görür ve KENDİ hesabını girer (`close.own`); vardiya açamaz, başkasının hesabına dokunamaz.
            "shifts.read",
            "shifts.close.own",
            // Yerel kasa: kendi istasyonundaki kasa satışlarını GÖRÜR; kampanya / ayar / PIN yönetemez.
            "pos.read",
            // Market: stoğu görür; mal kabul ve sayım okutması (tablet) kasiyerin işidir — küçük istasyonda tedarikçiyi kasiyer
            // karşılar. Sayım farkı onayı, transfer, fire ve sipariş müdürdedir.
            "market.read",
            "market.receipt.manage",
            "market.count.manage",
            // Müşteri (Prompt 17): kasiyer müşteriyi ve puanını görür (maskeli); kayıt ve kişisel veri müdürdedir.
            "customers.read",
            "loyalty.read",
            // Yıkama (Prompt 18): kasada satılan programı başlatır, kod / kredi verir, iş emrini teslim eder; maliyet raporu yok.
            "wash.read",
            "wash.operate",
            // Şarj (Prompt 19): canlı durumu görür, şarjı başlatır / durdurur, kilit açar; tarife ve rapor yok.
            "ev.read",
            "ev.operate",
            // Alarm (Prompt 20): istasyonunun operasyon alarmlarını GÖRÜR (tank, cihaz, vardiya); yönetemez.
            "alarms.read",
        ],
    },
    PUMP_ATTENDANT: {
        name: "Pompacı",
        description: "Pompa satışları ve vardiya",
        // `org.company.read`: vardiya ve akaryakıt sayfaları şirket seçimiyle açılır (kasiyerdeki not).
        permissions: [
            "org.company.read",
            "stations.read",
            "fuel.ops.read",
            "fuel.reading.create",
            "shifts.read",
            "shifts.close.own",
        ],
    },
    AUDITOR: { name: "Denetçi", description: "Tüm kayıtlarda salt okuma", permissions: [...readOnly] },
    // Prompt 17 (ADR 0017 §17): filo carisinin kendi kullanıcısı — atama YALNIZCA `COUNTERPARTY` kapsamında yapılır.
    FLEET_PORTAL_USER: {
        name: "Filo portalı kullanıcısı",
        description: "Filo carisinin kendi kullanıcısı: işlemler, faturalar, limitler, araç ekleme talebi",
        permissions: ["fleet.portal.access", "fleet.portal.vehicle.request"],
    },
    // Prompt 18 (ADR 0018 §3): el yıkama tableti — iş emri, fotoğraf, randevu, makine başlatma; fiyat / maliyet yönetmez.
    WASH_ATTENDANT: {
        name: "Yıkama görevlisi",
        description: "Yıkama iş emirleri, fotoğraflar, randevular ve makine başlatma",
        permissions: ["stations.read", "wash.read", "wash.operate", "files.upload", "files.read"],
    },
};
export const SYSTEM_ROLE_KEYS = Object.keys(SYSTEM_ROLES);
/**
 * `COUNTERPARTY` (Prompt 17): filo portalı kullanıcısının cari kapsamı. Yalnızca `FLEET_PORTAL_USER` rolüyle atanır ve
 * şirket / istasyon verisine ERİŞİM VERMEZ — yetkilendirme servisi bu kapsamı şirket / istasyon çözümlemesinde yok sayar.
 */
export const SCOPE_TYPES = ["TENANT", "COMPANY", "REGION", "STATION", "COUNTERPARTY"];
export const scopeTypeSchema = z.enum(SCOPE_TYPES);
/** Hassas işlemlerde "yakın zamanda doğrulandı" sayılma süresi. */
export const STEP_UP_WINDOW_SECONDS = 300;
//# sourceMappingURL=permissions.js.map